import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import useAgency from '@hooks/useAgency'
import useAgencySelector from '@hooks/useAgencySelector'

import PageHeader from '@components/PageHeader'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey?: string,
  children: ReactNode,
  agencyPayload: ReturnType<typeof useAgency>,
}

const PageLayout = (props: PageLayoutProps) => {
  const {
    activeTabBarItemKey,
    agencyPayload: {
      agency,
      urls,
    },
    children,
  } = props

  const { agenciesIndexUrl } = urls

  const { hasMultipleAgencies } = useAgencySelector()

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Edit Agency | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={hasMultipleAgencies && (
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || agenciesIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        nestedNavigation
        // @ts-expect-error TS2345
        tabBarItems={generateTabBarItems(agency, urls)}
        title="Edit Agency"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
